(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["asdr"]) return;
  try {
    
  const faqs = document.querySelector('.group-faq');
  ariaEnhanceFAQs();

  function ariaEnhanceFAQs() {
    if (!faqs) return;
    
    const questions = faqs.getElementsByTagName("dt");
    const answers = faqs.getElementsByTagName("dd");
    if (questions.length !== answers.length) return;

    for (let i = 0; i < questions.length; i++) {
      const questionContent = `<button type="button" aria-expanded="false" aria-controls="faq${i}_desc">` 
                              + questions[i].innerHTML
                              + '</button>';
      const answerContent = `<div id="faq${i}_desc" class="desc">`
                            + answers[i].innerHTML
                            + '</div>'
      questions[i].innerHTML = questionContent;
      answers[i].innerHTML = answerContent;
    }
  }

  } catch(e) { console.error(e); }
})();
})();
